import type { I18nFn } from '#/i18n/types/I18nFn';
import type { SearchFacetData } from '#/modules/search/types/SearchFacetData';
import { AREAS_OF_FOCUS } from '#/utils/constants/general/areasOfFocus';

export function eventAreasOfFocusFacet(i18n: I18nFn) {
  return {
    id: 'eventAreasOfFocusFacet',
    name: 'areasOfFocus',
    get title() {
      return i18n('Cause Areas');
    },
    type: 'array',
    options: Object.keys(AREAS_OF_FOCUS(i18n)),
    optionTitles: AREAS_OF_FOCUS(i18n),
  } as const satisfies SearchFacetData;
}
